import { display, margin } from "@mui/system";
import { color, line } from "d3";

export const useStyles = MUITheme => ({
	footerContainer:{
		background: 'var(--footer_bg)',
		padding: '7px 13px 2px',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		position:'fixed',
		bottom:0,
		left:0,
		right:0,
		zIndex:1300,
		[MUITheme.breakpoints.down("sm")]: {
			padding: '15px 0',
			flexDirection: 'column',
		}
	},
	chatWidget:{	
		position: 'fixed',
		bottom: 0,
		right: 10,
		zIndex: 1300,
		display: 'flex',
		alignItems: 'center',
		'& .footer-support-text':{
			color: '#9ea2ab',
			marginRight: 10,
			lineHeight: '50px',
		},
		'& .freshdesk-help-icon':{
			height: 40,
			width: 40,
			marginBottom: 4,
			borderRadius: 100,
			backgroundColor: '#55c1bf',
			textAlign: 'center',
			cursor: 'pointer',
			transition: 'all .2s ease',
			"& img":{
				width: 'auto',
				margin: '8px auto',
				height: 24,
			}
		},
		'& .help-popup':{
			position: 'absolute',	
			bottom: 50,
			right: 0,
		    zIndex: 1300,
		},
		'& .help-panel':{
			margin: '10px 0',
			display: 'flex',
			alignItems: 'center',
			width: 320,
			position: 'relative',
			cursor: 'pointer',
			transition: 'all .2s ease',
			'&:hover':{
				transform: 'translate(-8px)',
			},
			'&.help-desk':{
				'& h5':{
					color: '#498cca'
				},
				'& .freshdesk-help-icon':{
					backgroundColor: '#498cca',
				}
			},
			'&.help-chat':{
				'& h5':{
					color: '#8bbf3f'
				},
				'& .freshdesk-help-icon':{
					backgroundColor: '#8bbf3f',
				}
			},
			'& p':{
				margin: 0,
    			fontSize: 15
			},
			'& .freshdesk-help-icon':{
				position: 'absolute',
				right: 0,
				boxShadow: '0 0 2px #fff',
			}
		},
		'& .panel':{
			backgroundColor: '#fff',
    		border: '1px solid #fafbfc',
			padding: 20,
			marginBottom: 0,
			borderRadius: 15,
			width: 300,
			boxShadow: '0 0 20px #0003',
			'& .panel-body':{
				padding: '20px 40px 20px 20px',
			},
			'& h5':{
				fontWeight: 700,	
				textTransform: 'uppercase',
				fontSize: 18,
				margin: '0 0 8px',
			}
		}
	},
	versionDetails:{
		display: 'flex',
		alignItems: 'center',
		'& svg':{
			paddingRight: 16,
			color: '#CF3C32'
		},
		'& p':{
			margin: 0,
			color: 'var(--header_color)',
			fontFamily: 'var(--font_family)',
			fontSize: 12,
			fontWeight: 'bold',
			letterSpacing: .43,
			lineHeight: '12px',
			'& span':{ 
				display: 'block',
				fontWeight: 'normal',
			}
		}
	},
	footerDescription:{
		margin: 0,
		textAlign:'center',
		color: 'var(--header_color)',
		fontFamily: 'var(--font_family)',
		fontSize: 13,
		lineHeight: '20px',
		[MUITheme.breakpoints.down("sm")]: { padding: '10px 0' },
		'& .lr-link':{
			textDecoration:'none',
			color:'var(--color_primary)',
			'&:hover,:focus':{
				textDecoration:'underline',
			}
		}
	},
	footerLogo:{
		width: 104,
		lineHeight: 0,
		textAlign: 'center',
		'& span':{
			color: MUITheme.palette.text.blue.tertiary,
			fontFamily: MUITheme.typography.fontFamily.secondary,
			fontSize: 10,
			fontWeight: 600,
			lineHeight: '15px',
			textTransform: 'uppercase'
		},
		'& h1':{
			margin: 0,
			fontSize: 0,
			'& img':{ width: '100%' }
		}
	}
})